// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"302":"loginView","505":"rechargeview"}[chunkId] + "." + {"302":"c8547001","505":"9ee81701"}[chunkId] + ".css";
};